import React, { useState, useEffect } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import config from '../config.json';

const NavMenu = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [fullname, setFullname] = useState('');
  const roles = JSON.parse(localStorage.getItem('Roles'));

  const userAccess = {
      hasView: roles?.includes('View') || false,
      hasAdmin: roles?.includes('Admin') || false,
      hasApprover: roles?.includes('Approver') || false,
      hasStandard: roles?.includes('Standard') || false,
      hasReviewer: roles?.includes('Reviewer') || false,
  }
  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  };

  const decodeToken = () => {
    const token = localStorage.getItem('token');

    if (!token) {
      setAuthenticated(false);
      setFullname('');
      return;
    }
    try {
      const tokenPayload = JSON.parse(atob(token.split('.')[1]));
      setFullname(
            `${tokenPayload.FirstName || ''} ${tokenPayload.LastName || ''}`.trim());
      setAuthenticated(true);
    } catch (error) {
      console.error('Error decoding token:', error);
      setAuthenticated(false);
      setFullname('');
    }
  };

  useEffect(() => {
    decodeToken();
  }, []);

  const handleLogout = () => {
    if (window.confirm("Do you want to logout?") === true) {
      // Clear user data and navigate to the desired path
      window.localStorage.clear();
      setFullname('');
      setAuthenticated(false);
      window.location.href = `${config.identityUrl}/Identity/Account/Login`; // Replace '/login' with the desired logout path
    }
  };
  return (
    <header>
      <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container light>
        <div className="d-flex flex-column fs-6">
          <div className="d-flex align-items-center">
            <NavbarBrand tag={Link} to="/">
              <span className="h5">ETR Forms Portal</span>
            </NavbarBrand>
          </div>
          <div className="d-flex align-items-center">
            <Link to="#" className="text-muted me-2" onClick={handleLogout}>
              Logout
            </Link>
            <span className="text-muted me-2">|</span>
            <div className="text-muted">{authenticated ? fullname : ''}</div>
          </div>
        </div>

        <NavbarToggler onClick={toggleNavbar} className="mr-2" />
        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
          <ul className="navbar-nav flex-grow">
            {(userAccess.hasAdmin || userAccess.hasStandard) && (
              <NavItem>
                <NavLink tag={Link} className="text-dark" to="/employee-list">
                  Employee
                </NavLink>
              </NavItem>
            )}
            {(userAccess.hasView && !userAccess.hasReviewer) && (
              <NavItem>
                <NavLink tag={Link} className="text-dark" to="/overtime-list">
                  Overtime
                </NavLink>
              </NavItem>
            )}
            {(userAccess.hasView && !userAccess.hasReviewer) && (<NavItem>
              <NavLink tag={Link} className="text-dark" to="/leave-list">
                Leave
              </NavLink>
            </NavItem>)}
            {(userAccess.hasView && !userAccess.hasReviewer) && (<NavItem>
              <NavLink tag={Link} className="text-dark" to="/undertime-list">
                Undertime
              </NavLink>
            </NavItem>)}
            {(userAccess.hasView && !userAccess.hasReviewer) && (<NavItem>
              <NavLink tag={Link} className="text-dark" to="/timeentry-list">
                Time Entries
              </NavLink>
            </NavItem>)}
            {(userAccess.hasAdmin || userAccess.hasReviewer) && (
              <NavItem>
                <NavLink tag={Link} className="text-dark" to="/reportviews">
                  Report View
                </NavLink>
              </NavItem>
            )}
            {userAccess.hasAdmin && (
              <NavItem>
                <NavLink tag={Link} className="text-dark" to="/user-list">
                  Users
                </NavLink>
              </NavItem>
            )}
          </ul>
        </Collapse>
      </Navbar>
    </header>
  );
};

export default NavMenu;
